import api from '@shared/api';

const BASE_MPM_URL = `mpm`;

const mpmApi = {
  fetchModelsCount(workspace) {
    const url = `${BASE_MPM_URL}/v2/model/count?workspaceId=${workspace}`;

    return api.get(url);
  }
};

export default mpmApi;
